import { useState } from "react";
import { useSelector } from "react-redux";
import { BillingRuleEntity } from "../../../../../entities/ServicesEntities/BillingEntities/BillingRuleEntity";
import { BillingRuleToUserTypeEntity } from "../../../../../entities/ServicesEntities/BillingEntities/BillingRuleToUserTypeEntity";
import { CreateBillingRule } from "../../../../../entities/ServicesEntities/BillingEntities/CreateBillingRule";
import {
  ADD_EV_RULE_FORM_STEPS,
  BILLING_RULE_TYPES,
  RATE_CHARGE_BY_NAMES
} from "../../../../../enums/Enums";
import Strings from "../../../../../resources/Strings";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import AddEVRuleStep from "../Steps/AddEVRuleStep";
import * as biliingActionsService from "../../../../../services/ActionsService/BillingActionsService";
import classes from "../WizardForm.module.css";
import store from "../../../../../redux/Store";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { showErrorMessage, showUpdateSuccessMessage } from "../../../../../utils/MessagesUtils";
import { billingActions } from "../../../../../redux/reducers/BillingReducer";
import { BillingRuleRateEntity } from "../../../../../entities/ServicesEntities/BillingEntities/BillingRuleRateEntity";

const AddEVRuleForm = (props) => {
  const selectedSites = useSelector((state) => state.user.selectedSites);
  const [selectedSite, setSelectedSite] = useState(props.isEditMode ? props.site : selectedSites?.length >  0 ? selectedSites[0] : null );

  const [formData, setFormData] = useState({
    ruleId: props?.isEditMode ? props.id : 0,
    userType: props?.isEditMode ? props.billingRuleToUserTypes.map(er => er.userTypeId) : [],
    ruleName: props?.isEditMode ? props.ruleName : "",
    costPerKV: props?.isEditMode ? props.billingRuleRates[0]?.rateAmount : "",
    currencySymbol: "$",
    isStepSubmitted: false,
  });

  const [stateData, setStateData] = useState({
    currentStep: ADD_EV_RULE_FORM_STEPS.ADD_EV_RULE,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const updateEvRule = () => {
    const { ruleId, ruleName, userType, costPerKV } = formData;
    const billingUserTypes = userType.map(
      (userTypeId) => new BillingRuleToUserTypeEntity(0, ruleId, userTypeId)
    );
    
    let rates = [new BillingRuleRateEntity(props.billingRuleRates[0]?.id !== undefined ? parseInt(props.billingRuleRates[0]?.id) : 0, parseFloat(costPerKV), RATE_CHARGE_BY_NAMES.KV, 1, 99, 1, ruleId)];

    const EVRuleEntity = new CreateBillingRule(
      new BillingRuleEntity(
        ruleId,
        ruleName,
        selectedSite?.id,
        BILLING_RULE_TYPES.EV_RULE,
        billingUserTypes,
        rates
      )
    );

    biliingActionsService.updateBillingRule(EVRuleEntity).then((response) => {
      store.dispatch(commonActions.closeSideModal());
      if (response.data.isSuccess) {
        store.dispatch(billingActions.setBillingRules(response.data.entity));
        // show message on update
        showUpdateSuccessMessage();
      } else {
        showErrorMessage(response.data?.error);
      }
    });
  };

  const addEvRule = () => {
    const { ruleId, ruleName, userType, costPerKV } = formData;
    const billingUserTypes = userType.map(
      (userTypeId) => new BillingRuleToUserTypeEntity(0, 0, userTypeId)
    );
    
    let rates = [new BillingRuleRateEntity(0, costPerKV, RATE_CHARGE_BY_NAMES.KV, 1, 99, 1, 0)];

    const EVRuleEntity = new CreateBillingRule(
      new BillingRuleEntity(
        ruleId,
        ruleName,
        selectedSite?.id,
        BILLING_RULE_TYPES.EV_RULE,
        billingUserTypes,
        rates
      )
    );

    biliingActionsService.addBillingRule(EVRuleEntity).then((response) => {
      store.dispatch(commonActions.closeSideModal());
      if (response.data.isSuccess) {
        store.dispatch(billingActions.setBillingRules(response.data.entity));
        showUpdateSuccessMessage();
      } else {
        showErrorMessage(response.data?.error);
      }
    });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });

    if (stateData.isCurrentStepValid) {
      if (props?.isEditMode) {
        updateEvRule();
      } else {
        addEvRule();
      }
    }
  };

  return (
    <form name="AddEVRule" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <AddEVRuleStep
          currentStep={stateData.currentStep}
          handleChange={handleChange}
          handleCurrentStepValidity={handleCurrentStepValidity}
          selectedSite={selectedSite}
          setSelectedSite={setSelectedSite}
          isEditMode={props?.isEditMode}
          {...formData}
        />
      </div>
      {stateData.currentStep == stateData.totalSteps && (
        <div className={classes.next}>
          <EllipseButton type="submit">{props?.isEditMode ? Strings.SAVE_CHANGES : Strings.CREATE_RULE}</EllipseButton>
        </div>
      )}
    </form>
  );
};

export default AddEVRuleForm;
